import React from 'react';
import { LuChevronLeft, LuChevronRight, LuTicket } from 'react-icons/lu';
import { MdOutlineInfo, MdShoppingCart } from 'react-icons/md';
import CalendarButton from '../../components/CalendarButton';
import { Dropdown } from '../../components/Dropdown';
import { ItemsCartSmallScreen } from '../../components/ItemsCartSmallScreen';
import { Modal } from '../../components/Modal';
import ReactIcon, { default as Icon } from '../../components/ReactIcon';
import { SidebarCardShop } from '../../components/SidebarCardShop';
import { Loading } from '../../components/SurfingLoading';
import { WithoutElementsShop } from '../../components/WithoutElementsShop';
import { Render } from '../../helpers/Render';
import { SectionsEnum, sectionsConst } from '../../helpers/utils';
import { useModalParkLogic } from './logic/useModalParkLogic';
import { CardShop } from './pieces/CardShop';
import {
    HeaderFilters,
    ModalFilterHeaderWrap,
    ModalShoppingWrapper,
    ScrollWrap,
    ShopValuesWrap,
    TextWarn,
    WarnShoppingTextIcon,
    WrapElementsSmallBig,
    WrapIconCartArrow,
} from './styles';
import { isUndecidedDate } from '../../components/Calendar';

export const ModalPark: React.FC = () => {
    const {
        currentDate,
        isPending,
        matchQuery,
        parkDatas,
        isVisible,
        cartIsVisible,
        handleAddToCart,
        setCartIsVisible,
        setCurrentDate,
        setCurrentSectionHandle,
        setModalIsVisible,
    } = useModalParkLogic();

    const currentDateFixed = isUndecidedDate(currentDate)
        ? new Date()
        : currentDate;

    const normalizedParkDatas = Array.isArray(parkDatas) ? parkDatas : [];

    const filteredParkItems = normalizedParkDatas.filter(
    item => item.information2?.toLowerCase() !== 'bilheteria'
    );

    return (
        <Modal
            title="Conheça nosso parque"
            showModal={isVisible}
            setShowModal={setModalIsVisible}
            stylesChildren={{
                height: '100%',
            }}
        >
            {isPending && <Loading />}
            <WrapElementsSmallBig isBigScreen={matchQuery}>
                <ModalShoppingWrapper cartMobileIsOpen={cartIsVisible}>
                    <HeaderFilters>
                        <ModalFilterHeaderWrap>
                            <Dropdown
                                setCurrentSelected={setCurrentSectionHandle}
                                title={SectionsEnum.TIKECETS}
                                elements={sectionsConst.map(item => ({
                                    id: item,
                                    value: item,
                                }))}
                                allSize={!matchQuery}
                            />

                            <CalendarButton
                                defaultDate={currentDateFixed}
                                onDateChange={date => {
                                    if (!date) return;
                                    setCurrentDate(date);
                                }}
                                textInput={matchQuery ? undefined : 'Data'}
                            />
                        </ModalFilterHeaderWrap>
                        <WrapIconCartArrow
                            isSmallScreen={!matchQuery}
                            onClick={() => setCartIsVisible(!cartIsVisible)}
                        >
                            <Icon Icon={MdShoppingCart} size={'1.5rem'} />
                            <Icon
                                Icon={
                                    cartIsVisible
                                        ? LuChevronLeft
                                        : LuChevronRight
                                }
                                size={'1.5rem'}
                            />
                        </WrapIconCartArrow>
                    </HeaderFilters>

                    {!!filteredParkItems && filteredParkItems?.length > 0 ? (
                        <ScrollWrap>
                            <ShopValuesWrap>
                                <WarnShoppingTextIcon>
                                    <ReactIcon
                                        Icon={MdOutlineInfo}
                                        size={'1.5rem'}
                                        color="#453B1E"
                                    />
                                    <TextWarn>
                                        O ticket de acesso ao parque não dá
                                        direito a surfar na piscina de ondas.
                                    </TextWarn>
                                </WarnShoppingTextIcon>
                                {filteredParkItems.map((item, index) => (
                                    <CardShop
                                        key={index}
                                        itemShop={item}
                                        date={currentDate}
                                        handleAddToCart={handleAddToCart}
                                    />
                                ))}
                            </ShopValuesWrap>
                        </ScrollWrap>
                    ) : (
                        <WithoutElementsShop
                            icon={LuTicket}
                            title="Não temos ingressos disponíveis."
                        />
                    )}
                </ModalShoppingWrapper>

                {/* Componente de carrinho para telas menores */}
                <Render show={!matchQuery}>
                    <ItemsCartSmallScreen
                        shopVisible={cartIsVisible}
                        setShopVisible={() => setCartIsVisible(!cartIsVisible)}
                    />
                </Render>

                {/* Card de shopping (sidebar) */}
                <Render show={matchQuery}>
                    <SidebarCardShop />
                </Render>
            </WrapElementsSmallBig>
        </Modal>
    );
};
